export default __webpack_public_path__ + "static/media/button-screen.701fb43f.png";